import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
var CQAAcceptEditReferenceValuePopUp = function (_ref) {
    var data = _ref.data, columns = _ref.columns;
    var currValue = data;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        rows: currValue || [],
        dataGridProps: {
            hideFooter: true
        }
    }));
};
export default CQAAcceptEditReferenceValuePopUp;
